function swymCallbackFn(swat){
    // your API calls go here
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".product-grid");
  })
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

//ghd catogery mf_ multiple filter issue


  document.addEventListener("DOMContentLoaded", function () {
    const isGHDCollection = window.location.pathname.includes("/collections/ghd");

    if (!isGHDCollection) return;

    // Look for the Wetline checkbox under category filter
    const observer = new MutationObserver(() => {
      const wetlineCheckbox = Array.from(document.querySelectorAll('[data-type="category"]')).find(el =>
        el.textContent?.trim().toLowerCase().includes("wetline")
      );

      if (wetlineCheckbox && !wetlineCheckbox.dataset._patched) {
        wetlineCheckbox.dataset._patched = true;

        wetlineCheckbox.addEventListener("click", function () {
          const url = new URL(window.location.href);
          const hasMetaWetline = url.searchParams.get("mf_custom_collection:text")?.toLowerCase() === "wetline";

          if (hasMetaWetline) {
            // Remove metafield and redirect
            url.searchParams.delete("mf_custom_collection:text");
            window.location.href = url.toString();
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });



document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('scroll', () => {
    if (window.innerWidth < 990) return; // Only run on 990px and up

    const sticky = document.querySelector('.shopify-section-header-sticky');

    const hideTargets = [
      sticky.querySelector('.background_bela'),
      sticky.querySelector('.header__left'),
      sticky.querySelector('.header_center_d'),
      sticky.querySelector('.header__right')
    ];

    const stickyLogo = sticky.querySelector('.stickylogo');
    const menuSplit = sticky.querySelector('.header__menu-split');

    const stickyTop = sticky.getBoundingClientRect().top;

    hideTargets.forEach(el => {
      if (el) el.style.display = (stickyTop <= 0) ? 'none' : '';
    });

    if (stickyLogo) {
      stickyLogo.style.display = (stickyTop <= 0) ? 'block' : '';
    }

    if (menuSplit) {
      menuSplit.style.marginTop = (stickyTop <= 0) ? '-27px' : '';
    }
  });
});







